exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/luiscordero29/Projects/luiscordero29/angular/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main